import React from "react";
import { Link } from "gatsby";

const Links = ({ styleClass }) => {
  return (
    <ul className={styleClass}>
      <li>
        <Link to="/">home</Link>
      </li>
      <li>
        <Link to="/projects">projects</Link>
      </li>
      <li>
        <Link to="/posts">posts</Link>
      </li>
    </ul>
  );
};

export default Links;
